import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import { IFgtsPeriodsReview } from '../../FgtsStep/interfaces';
import {
  FooterLabelCell,
  StyledDivider,
  StyledGroup,
  StyledInfo,
  StyledTableContainer,
  StyledWrapper,
} from './styles';
import { TextM } from 'app/components';
import { TSimulatorV2Response } from 'app/services/simulatorHttpServiceV2';

interface FgtsReviewTableProps {
  data: IFgtsPeriodsReview[];
  simulationResponse: TSimulatorV2Response | null;
}

const FgtsReviewTable = ({
  data,
  simulationResponse,
}: FgtsReviewTableProps) => {
  // Variables
  const totalAvailable = data.reduce((acc, item) => acc + item.available, 0);
  const totalAmount = data.reduce((acc, item) => acc + item.amount, 0);
  const saldoRestante = totalAvailable - totalAmount;
  const netAmount = simulationResponse?.requested_amount || 0;
  const financedAmount = simulationResponse?.total_amount_owed || 0;

  return (
    <>
      <StyledWrapper>
        <StyledGroup>
          <StyledInfo>
            <TextM weight="Bold">Nome do produto</TextM>
            <TextM>Antecipação FGTS</TextM>
          </StyledInfo>
          <Divider />
          <StyledInfo>
            <TextM weight="Bold">Valor total a receber</TextM>
            <TextM>
              R${' '}
              {netAmount.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}
            </TextM>
          </StyledInfo>
          <Divider />
          <StyledInfo>
            <TextM weight="Bold">Valor tomado de margem</TextM>
            <TextM>
              R${' '}
              {financedAmount.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}
            </TextM>
          </StyledInfo>
        </StyledGroup>
        <StyledDivider />
        <StyledGroup>
          <StyledInfo>
            <TextM weight="Bold">Saldo disponível</TextM>
            <TextM>
              R${' '}
              {totalAvailable.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}
            </TextM>
          </StyledInfo>
          <Divider />
          <StyledInfo>
            <TextM weight="Bold">Sado restante</TextM>
            <TextM>
              R${' '}
              {saldoRestante.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}
            </TextM>
          </StyledInfo>
        </StyledGroup>
      </StyledWrapper>

      <StyledTableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>
                <TextM weight="Bold">Data de aniversário</TextM>
              </TableCell>
              <TableCell align="left">
                <TextM weight="Bold">Saldo disponível</TextM>
              </TableCell>
              <TableCell align="left">
                <TextM weight="Bold">Valor tomado de margem</TextM>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextM weight="Bold">{index + 1}</TextM>
                </TableCell>
                <TableCell>
                  {new Date(row.credit_date).toLocaleDateString('pt-BR')}
                </TableCell>
                <TableCell align="left">
                  R${' '}
                  {row.available.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}
                </TableCell>
                <TableCell align="left">
                  R${' '}
                  {row.amount.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <FooterLabelCell colSpan={2} />
              <FooterLabelCell align="left">
                <TextM weight="Bold">Saldo total disponível</TextM>
                <p>
                  {' '}
                  R${' '}
                  {totalAvailable.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}
                </p>
              </FooterLabelCell>
              <FooterLabelCell align="left">
                <TextM weight="Bold">Valor total tomado de margem</TextM>
                <p>
                  R${' '}
                  {totalAmount.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                  })}
                </p>
              </FooterLabelCell>
            </TableRow>
          </TableFooter>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export default FgtsReviewTable;
